import { EventEmitter, ChangeDetectorRef, OnChanges } from '@angular/core';
var AngularWizardStepComponent = /** @class */ (function () {
    function AngularWizardStepComponent(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.hidden = false;
        this.isValid = true;
        this.showNext = true;
        this.showPrev = true;
        this.onNext = new EventEmitter();
        this.onPrev = new EventEmitter();
        this.onComplete = new EventEmitter();
        this._isActive = false;
        this.isDisabled = true;
    }
    AngularWizardStepComponent.prototype.ngOnChanges = function () {
        // this
    };
    Object.defineProperty(AngularWizardStepComponent.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (isActive) {
            this._isActive = isActive;
            this.isDisabled = false;
            this._changeDetectorRef.detectChanges(); // workaround for ISSUE https://github.com/angular/angular/issues/6005
        },
        enumerable: true,
        configurable: true
    });
    return AngularWizardStepComponent;
}());
export { AngularWizardStepComponent };
